import {
  STORAGE_KEY_CHECK_PASSWORD_API_CALLED_DATE,
  STORAGE_KEY_PASSWORD_VALID_END_DATE,
} from "@/types";

export const handlePasswordExpiredInfo = () => {
  const updateValidEndDate = (validEndate: string) =>
    window.localStorage.setItem(
      STORAGE_KEY_PASSWORD_VALID_END_DATE,
      validEndate
    );

  const updateCheckPasswordCalledDate = (calledDate: string) =>
    window.localStorage.setItem(
      STORAGE_KEY_CHECK_PASSWORD_API_CALLED_DATE,
      calledDate
    );

  const getValidEndDate = () =>
    window.localStorage.getItem(STORAGE_KEY_PASSWORD_VALID_END_DATE);

  const getCheckPasswordCalledDate = () =>
    window.localStorage.getItem(STORAGE_KEY_CHECK_PASSWORD_API_CALLED_DATE);

  const removeValidaEndDate = () =>
    window.localStorage.removeItem(STORAGE_KEY_PASSWORD_VALID_END_DATE);

  const removeCheckPasswordCalledDate = () =>
    window.localStorage.removeItem(STORAGE_KEY_CHECK_PASSWORD_API_CALLED_DATE);

  return {
    updateValidEndDate,
    updateCheckPasswordCalledDate,
    getValidEndDate,
    getCheckPasswordCalledDate,
    removeValidaEndDate,
    removeCheckPasswordCalledDate,
  };
};
